import React from 'react'
import PropTypes from 'prop-types'
import { Button, Table } from 'antd'
import {
    HISTORY_PAGE_SIZE, formatDateTime, isHandoverImageExpired,
} from '../../helpers/history'

const HistoryTable = ({ loading, items, total, page, onChangePage, onViewDetail, onPrint }) => {
    const columns = [
        {
            title: 'Số phiếu',
            dataIndex: 'code',
            key: 'code',
            render: code => <b className='Mono'>{code}</b>,
        },
        {
            title: 'Thời gian giao',
            dataIndex: 'handed_at',
            key: 'handed_at',
            render: formatDateTime,
        },
        {
            title: 'Đối tác may',
            key: 'partner',
            render: (_, record) => (record.partner_snapshot && record.partner_snapshot.name) || '—',
        },
        {
            title: 'Người giao',
            key: 'handed_by',
            render: (_, record) => (record.handed_by && record.handed_by.username) || '—',
        },
        {
            title: 'Số lô',
            dataIndex: 'total_batches',
            key: 'total_batches',
            align: 'right',
        },
        {
            title: 'Tổng SL',
            dataIndex: 'total_quantity',
            key: 'total_quantity',
            align: 'right',
        },
        {
            title: 'Ảnh',
            key: 'images',
            render: (_, record) => {
                if (isHandoverImageExpired(record.handed_at)) return <span className='TextMuted'>Hết hạn lưu</span>
                if (!record.total_images) return <span className='TextMuted'>Không có ảnh</span>

                return `${record.total_images} ảnh`
            },
        },
        {
            title: 'Lần in',
            dataIndex: 'print_count',
            key: 'print_count',
            align: 'right',
            render: value => value || 0,
        },
        {
            title: 'Thao tác',
            key: 'actions',
            render: (_, record) => (
                <span className='HistoryTable__actions'>
                    <Button type='link' size='small' onClick={() => onViewDetail(record._id)}>Xem</Button>
                    <Button type='link' size='small' onClick={() => onPrint(record._id)}>In phiếu</Button>
                </span>
            ),
        },
    ]

    return (
        <Table
            className='HistoryTable'
            rowKey='_id'
            size='middle'
            loading={loading}
            columns={columns}
            dataSource={items}
            locale={{ emptyText: 'Không có lần giao may nào' }}
            pagination={{
                current: page,
                pageSize: HISTORY_PAGE_SIZE,
                total,
                onChange: onChangePage,
                showTotal: count => `${count} lần giao · ${HISTORY_PAGE_SIZE} / trang`,
            }}
        />
    )
}

HistoryTable.propTypes = {
    loading: PropTypes.bool.isRequired,
    items: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    onViewDetail: PropTypes.func.isRequired,
    onPrint: PropTypes.func.isRequired,
}

export default HistoryTable
